import(/* webpackMode: "eager", webpackExports: ["ChatWidget"] */ "/app/src/components/chat/ChatWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/SafeLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/puck/PuckRenderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeInjector"] */ "/app/src/components/theme/ThemeInjector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/common/components/localized-client-link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/layout/components/cart-dropdown/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/layout/components/cart-mismatch-banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/layout/components/side-menu/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/layout/templates/footer/themed-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/layout/templates/nav/themed-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/shipping/components/free-shipping-price-nudge/index.tsx");
